import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useStore } from '@/models';
import { initZendeskWidget } from '@/config/zendesk';

const BaseInfoRequester: React.FC = () => {
  const { coin, account } = useStore();

  const { fetchAssistPriceMap, userInfo, isLogin, lang } = account;

  const { fetchSymbolList, fetchPairSets, fetchPairAll, fetchCoinsConfig } = coin;
  useEffect(() => {
    fetchSymbolList();
    fetchPairSets();
    fetchAssistPriceMap();
    fetchCoinsConfig();
    fetchPairAll();
  }, []);

  // 全局预热 Zendesk：在任意页提前排队 JWT / 会话字段，减轻首次打开时延迟与异常时间展示
  useEffect(() => {
    initZendeskWidget(isLogin && userInfo?.id ? userInfo : null, lang);
  }, [isLogin, userInfo?.id, lang]);

  return <></>;
};

export default observer(BaseInfoRequester);
